import { generatedAPI } from './endpoints.gen';

export const scopeAPIv0alpha1 = generatedAPI;
